import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const routes = [
  {
    path: "/",
    name: "login",
    isHide: false,
    component: () =>
        import ("../views/login.vue"),
   },
  {
  path: '/home',
  name: 'home',
  component: () => import('../views/homeView.vue')
}

]
const router = new VueRouter({
  mode: "history",
  routes
})

export default router